import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  get1sxyiyz2qwf4j as get,
  set13o7dd1nq2lc5 as set,
  Attributes2dg90yv0ot9wx as Attributes,
} from './Attributes.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AttributesJsFn(concurrent) {
  concurrent = concurrent === VOID ? false : concurrent;
  return new (AttributesJs())();
}
var AttributesJsClass;
function AttributesJs() {
  if (AttributesJsClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.m4w_1 = LinkedHashMap().fc();
      }
      z4p(key) {
        return this.m4w_1.v4(key);
      }
      a4q(key) {
        return this.m4w_1.t4(key);
      }
      b4q(key, value) {
        // Inline function 'kotlin.collections.set' call
        this.m4w_1.b5(key, value);
      }
      d4q(key) {
        this.m4w_1.c5(key);
      }
      e4q(key, block) {
        var tmp0_safe_receiver = this.m4w_1.v4(key);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
        }
        // Inline function 'kotlin.also' call
        var this_0 = block();
        // Inline function 'kotlin.collections.set' call
        this.m4w_1.b5(key, this_0);
        return this_0;
      }
      f4q() {
        return toList(this.m4w_1.w4());
      }
    }
    protoOf($).y4p = get;
    protoOf($).c4q = set;
    initMetadataForClass($, 'AttributesJs', AttributesJs, VOID, [Attributes()]);
    AttributesJsClass = $;
  }
  return AttributesJsClass;
}
//region block: exports
export {
  AttributesJsFn as AttributesJsFn25rjfgcprgprf,
};
//endregion

//# sourceMappingURL=Attributes.web.mjs.map
